import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Feedback() {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="feedback-area ptb-120">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-3 col-md-12">
            <div className="feedback-wrap-content">
              <span className="sub">Tales From The Real Estate</span>
              <h2>Our Clients Feedback.</h2>
            </div>
          </div>
          <div className="col-lg-9 col-md-12">
            <Slider {...settings}>
              <div>
                <div className="feedback-card">
                  <ul className="rating">
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li className="gray">
                      <i className="ri-star-fill"></i>
                    </li>
                  </ul>
                  <p>
                    "I recently invested in a property with this company, and
                    I’m extremely satisfied. The development is progressing
                    rapidly, and the amenities like the park, gym, temple, yoga
                    center, and kids' play area are impressive. The staff is
                    always polite, professional, and quick to respond. My family
                    and I are thrilled with our new home!
                    <br />
                    Thank you Gateway LANDMARK GROUP.”
                  </p>
                  <div className="info">
                    <h3>Sunil Sharma</h3>
                  </div>
                </div>
              </div>

              <div>
                <div className="feedback-card">
                  <ul className="rating">
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                  </ul>
                  <p>
                    “My father took a plot of Nirwaan Vikas from Gateway Landmark
                    Group1 year ago and today its price has increased by 10%.
                    Thank you sir.”
                  </p>
                  <div className="info">
                    <h3>Amrita Kumari</h3>
                  </div>
                </div>
              </div>

              <div>
                <div className="feedback-card">
                  <ul className="rating">
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li className="gray">
                      <i className="ri-star-fill"></i>
                    </li>
                  </ul>
                  <p>
                    “Thanks to Gateway Landmark GroupScheme One, I was able to
                    successfully sell my plot. The process was smooth, and I
                    appreciate their support throughout. Thank you,Gateway
                    LANDMARK GROUP!"
                  </p>
                  <div className="info">
                    <h3>Mr. Manoj Kumawat</h3>
                  </div>
                </div>
              </div>

              <div>
                <div className="feedback-card">
                  <ul className="rating">
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                    <li>
                      <i className="ri-star-fill"></i>
                    </li>
                  </ul>
                  <p>
                    “ Gateway Landmark Groupis good & best property provider
                    company in Jaipur. I purchased a property recently, and the
                    overall experience is nice. Thank you Gateway LANDMARK
                    GROUP.”
                  </p>
                  <div className="info">
                    <h3>Mr. Sourbh Bairwa</h3>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Feedback;
